import { Avatar, ListItemText, Typography, Button } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import React, { useState } from "react";
import { IReduxState } from "../../store";
import Badge from '@mui/material/Badge';
import { IParentStudentItem } from "../../store/focusEcoleSlice";

export interface IListeProps {
  localStudentDatasFiltered: IParentStudentItem[];
}

const Liste = (props: IListeProps) => {
  const { localStudentDatasFiltered } = props;

  // Redux
  const dataFiltered = useSelector((state: IReduxState) => state.focusEcole.dataFiltered);
  const students = useSelector((state: IReduxState) => state.focusEcole.students);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // Calculate total pages
  const totalPages = Math.ceil(localStudentDatasFiltered.length / itemsPerPage);

  // Slice data for current page
  const currentData = localStudentDatasFiltered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <>
      <div style={{ padding: 10, height: "40vh", overflow: "auto", marginTop: 10 }}>
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {dataFiltered.filter(et => et.codeEtab === "035048").map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      item.status === 0
                        ? <Badge badgeContent="Impayé" color="warning" />
                        : <Badge badgeContent="Payé" color="success" />
                    }
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Avatar alt="" src={item?.photo} />
                      </ListItemIcon>
                      <ListItemButton>
                        <ListItemText
                          primary={`${item.nomEleve} ${item.prenomEleve}`}
                          secondary={
                            <Box style={{ display: "flex", flexDirection: "column" }}>
                              <Typography variant="caption">
                                {`${item.libelleClasseCourt} - ${item.matricule ? item.matricule : item.idEleve}`}
                              </Typography>
                              <Typography variant="caption">
                                {`Année scolaire: ${item.anneeScolaire}`}
                              </Typography>
                              <Typography variant="caption">
                                {`Etablissement: ${item.codeEtab} - ${item.libEtab}`}
                              </Typography>
                              <Typography variant="caption">
                                Parent:
                                <span style={{ fontWeight: "bold" }}>
                                  {` ${item.filiation} - ${item.nomPrenomParent} - ${item.numeroCellulaire}`}
                                </span>
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>

      {/* Pagination Controls */}
      <Box display="flex" justifyContent="space-between" marginTop={2}>
        <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
          Précédent
        </Button>
        <Typography>{`${currentPage} / ${totalPages}`}</Typography>
        <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
          Suivant
        </Button>
      </Box>

    </>
  );
};

export default Liste;
